/**
 * Turning hosted routing on.
 *
 * One call at boot, before any module builds its assistant panel. Off by
 * default: with no flag set the app behaves exactly as it did before this
 * directory existed, which is what keeps the offline classroom and the CI
 * physics checks honest.
 *
 * Enable with `VITE_ASSISTANT_LLM=on` at build time. That flag carries no
 * secret - it says "a proxy is deployed", nothing more. The keys live in the
 * proxy and are never part of a bundle a student can open.
 */

import { installRouterFactory } from '../Assistant'
import { createLlmRouter } from './router'

export { lastRouteMeta, type RouteMeta } from './router'
export { currentRegion, setRegion } from './region'
export { currentProvider, providerChoice, setProvider, type ProviderChoice } from './provider'
export { PROVIDERS, PROVIDER_FOR_REGION, providerFor } from './config'
export type { ProviderId, Region } from './config'

export const hostedRoutingEnabled = (): boolean =>
  import.meta.env.VITE_ASSISTANT_LLM === 'on'

/**
 * Install the hosted router if it is configured. Safe to call unconditionally -
 * it is a no-op when the flag is unset.
 */
export function setupAssistantRouting(): void {
  if (!hostedRoutingEnabled()) return
  installRouterFactory(createLlmRouter)
}
